/**
 * Static Ads der US-Testmarke HOTTY BBQ US, die im Projekt-Flow in die Ad
 * Library übernommen und damit zur Veröffentlichung freigegeben wurden
 * (47 Motive, Stand 27.08.2026, Tabelle `meta_ad_library` der Brand
 * b946f4a9-c134-4e95-b3f6-d54dd09e0ed1).
 *
 * Abgrenzung zu `publishedStaticGridAds`: die deutschen Motive sind bei Meta
 * gelaufen und tragen eine Meta-Ad-ID. Diese hier sind freigegeben, aber nicht
 * ausgespielt — die englischen Beschriftungen duerfen daher "live" oder
 * "published" NICHT behaupten.
 *
 * Alle Motive sind 928x1152 (4:5) und stammen aus dem Still-Ad-Creator.
 */
export type ApprovedStaticAdUs = Readonly<{
  src: string;
  assetId: string;
  product: string;
}>;

export const APPROVED_STATIC_ADS_US: readonly ApprovedStaticAdUs[] = [
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/da84d453-f249-4304-943b-8a4a7708ffbd.jpg",
    assetId: "18b5e2f9-8ff4-40e2-ab7a-b536317fd0ee",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/43657dda-51fc-4464-a303-89cbabd69adc.jpg",
    assetId: "71817de7-51f4-41c4-bd02-f6a8ac12d624",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/35c7dbd6-94e7-40a5-8014-7ca684cdd351.jpg",
    assetId: "305d273a-a0fe-4dbf-b092-4d30b4cba275",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/77c4eeeb-81b9-4834-871c-3087add89b5f.jpg",
    assetId: "cda7ac2f-2496-424b-95b4-009b6210418f",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/076382bc-f3ce-4745-bd4f-dc6465d42d7e.jpg",
    assetId: "4220bae5-e6ad-468b-9326-ed7795bbca8b",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/645e0929-382e-437f-a21d-4f7cf09adc94.jpg",
    assetId: "b042e056-c1db-4c9f-9dd2-5c6c42506f1c",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/544d97f6-0978-429c-b260-a3cfe7fa5bbe.jpg",
    assetId: "b3beb4e9-9830-4229-b8d1-1d827d779a06",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/82072f2d-97e3-48d5-9c75-b74e0991daf1.jpg",
    assetId: "73e5e49a-1f9a-4fa5-bd5b-12449bc1d76c",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/dcd48172-e6fe-47cf-8a40-567c618cb1b7.jpg",
    assetId: "54788317-d902-4aa1-9e46-8ea99f1fe740",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/9ad544b6-3f29-40f1-963e-c9c536dc0663.jpg",
    assetId: "64693628-82d7-4679-b2d7-481c7547f922",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/b145202d-d05e-4014-95a6-18ce37de4f97.jpg",
    assetId: "447ed363-ab9f-44f7-bf75-b762b249e1c8",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/9322d82d-07a9-47e7-bcbe-66f3269a4aa7.jpg",
    assetId: "079a8557-2f13-4279-bb1e-36c11e5df50c",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/dd889b56-4e28-4c07-b9a3-1be3a915cc1b.jpg",
    assetId: "474a02f3-5f54-4f4f-85f5-0f752dac9bc9",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/4e460451-00ab-442d-bbe3-657ea8b6cbed.jpg",
    assetId: "20377217-c22a-4f17-860f-8afa075b0f33",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/bc448698-3d74-4e61-aba2-7057486b4fdd.jpg",
    assetId: "38c9f584-f53b-46d7-b103-ecf27f9f4927",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/069f53ea-48d5-4943-b0ea-90f0a4d129fb.jpg",
    assetId: "f8d82003-c69b-4192-98a8-c09e3679a1c2",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/889fc60b-065a-4897-be53-794b9e0a0bef.jpg",
    assetId: "68faec6d-9d3f-4419-86e9-1fc4374fc986",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/d56f9965-9b0a-4a78-8f3d-645a44d90dff.jpg",
    assetId: "e391ccb5-6979-46cc-ac32-f8bac28f5bfe",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/6b6e48f5-58c8-4072-88c8-cb1ba79631d5.jpg",
    assetId: "d379e80e-463e-48dc-b40a-d08e21387164",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/b9a970c9-6b0a-43de-90e9-71d0cecc76b2.jpg",
    assetId: "cc7b8f05-3cb0-4de8-a977-3a584bdc1f30",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/74e31935-29f0-47de-a1e2-20ac5b41646d.jpg",
    assetId: "ed7f7678-461f-4ddd-9f8f-315e78f78787",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/29b66654-3d20-4453-85cd-84a1660cf653.jpg",
    assetId: "9663aaa2-147a-4af6-9fc8-6bba4cd8c510",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/0243d86d-506f-4d87-a884-852af77fb2be.jpg",
    assetId: "ac3ed526-2dd6-4ad1-89e8-41dbae8dc5e5",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/405a9eeb-1390-409f-b200-41c3c5984e43.jpg",
    assetId: "398e223b-66ed-47aa-9ec9-03a12d22f9ab",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/347a5735-c59a-46c3-a3f7-524fe61e7289.jpg",
    assetId: "7753cd22-9b75-4d8d-bdb9-fae852f0b323",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/3d2bb3dc-ee58-45d7-84d0-e584659ae26a.jpg",
    assetId: "dea59fde-13ac-4013-9de0-2d39f5990d0a",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/49d19d98-85c8-4c4a-8142-5c29870e49b0.jpg",
    assetId: "b9e0d85e-cd0f-4077-93e9-97f022157def",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/8f93c7aa-253f-49ae-9229-3c92162350d2.jpg",
    assetId: "2fd86419-e20d-471b-9ce5-7230c273e914",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/9a2a8a44-d9c4-4316-9cbc-bf265d9252e5.jpg",
    assetId: "5c6aae3a-2e3b-49e1-9c84-e4a9bebe2e4f",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/522b1c7f-a635-4168-b163-ad04e8a96e28.jpg",
    assetId: "2ffa5743-678d-4a60-aec4-a01ae432c04e",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/91e60e7b-d267-4056-a093-0650ea71d70a.jpg",
    assetId: "df794b64-6d8a-4767-a857-d7014589bb9b",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/79ba2834-4f17-4a8c-bcf8-e47022add98a.jpg",
    assetId: "b1f92b70-dc26-413a-92ac-e0016912f2c2",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/540f4441-6dab-467d-9c33-c4c12f98722a.jpg",
    assetId: "52d656d4-ccdb-4291-80bf-ea453f0ec3fe",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/0c136843-cb45-4f75-961f-1af9b08bb9cb.jpg",
    assetId: "48a0c26d-b7b0-4786-a5ea-e27ba5470847",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/071b8383-0683-469b-96e0-2ef6ad798e8b.jpg",
    assetId: "e4d9f4db-c99a-41b6-a633-ce11f0a9e00e",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/845b9dd5-2c40-488f-8dbd-9b5a22eb9059.jpg",
    assetId: "71e41a44-3dff-4b6a-a26e-7f6b671515a1",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/1be30a8d-97d6-4463-963e-15b66a6a4c41.jpg",
    assetId: "185cf8ce-ee54-4da2-9591-b77858acdd41",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/76554bea-e4cf-4998-b838-0abfb33edc0f.jpg",
    assetId: "44d43bac-3716-463b-98e1-62d3680ec265",
    product: "Icebucket",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/6c38b063-5601-4180-af77-8cb2cb58c42f.jpg",
    assetId: "ecf8d562-07c4-4418-b685-f763f8448fb6",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/87d002c7-2a2f-4a52-b6c1-9e92927000c8.jpg",
    assetId: "0bd2e9d6-9fdb-4549-87dd-ca146a3947f5",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/3cdc70b1-5012-4e85-ac45-14577e884ffc.jpg",
    assetId: "632a7671-0f2e-4fe9-a9bd-c7b955ebe1ff",
    product: "Aperitif Bar Manhattan",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/9daaa150-6e9a-476c-817c-db636774c9c5.jpg",
    assetId: "87ca0e8a-5ef5-4773-bd65-e4d87f91af6b",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/9cfcd4f6-5b0d-41d9-a671-12df4eca9c9e.jpg",
    assetId: "5b450376-dca8-4bdc-9001-0d97c3e0d0ba",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/1c36c1e5-e4f8-4654-bd58-54123f8029df.jpg",
    assetId: "fce16005-afb5-4272-8536-bcbd6c4cd279",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/35e74b3a-03e9-428c-9119-74fecae3b987.jpg",
    assetId: "03cf6898-5c6d-43cf-863a-bc918f8b6e33",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/c365c00d-9118-4172-b278-55f1d7d11158.jpg",
    assetId: "720d730e-0b1e-41cd-9ad0-e93d00ebe5e8",
    product: "Hotty Legacy",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/b946f4a9-c134-4e95-b3f6-d54dd09e0ed1/e8746fd7-f668-4ef5-9e8c-31c91b64c0a0.jpg",
    assetId: "a1d391dd-c42e-442b-8cbf-7fcd53066764",
    product: "Hotty Legacy",
  },
] as const;
